import { memo, useEffect, useState } from 'react';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';


// filters
const FILTER_INVESTMENT_TYPES = [
    {
        id: null,
        label: "All"
    },
    {
        id: 1,
        label: "IFSH investment"
    },
    {
        id: 2,
        label: "Outside investment"
    },
];

const RESET_FILTER = {
    id: null,
    label: "All"
};

function PortfolioFilterModal(props) {

    const filter_investment_options = props.filterOptionsInvestment || FILTER_INVESTMENT_TYPES;
    const [filterPortfolioFor, setFilterPortfolioFor] = useState(props.selectedFilterPortfolioFor);
    const [filterInvestmentType, setFilterInvestmentType] = useState(props.selectedFilterInvestmentType);

    useEffect(() => {
        setFilterPortfolioFor(props.selectedFilterPortfolioFor);
    }, [props.selectedFilterPortfolioFor]);

    useEffect(() => {
        setFilterInvestmentType(props.selectedFilterInvestmentType);
    }, [props.selectedFilterInvestmentType]);

    const _handleOnClickCancelbtn = () => {
        props.handleSelectedFilters(props.selectedFilterPortfolioFor, false);
    };

    const _handleOnClickApplybtn = () => {
        props.handleSelectedFilters(filterPortfolioFor, filterInvestmentType, true);
    };

    const _handleFilterTypeSelect = (selected_filter, type) => {
        if (type === 1) {
            setFilterPortfolioFor(selected_filter);
        } else if (type === 2) {
            setFilterInvestmentType(selected_filter);
        }
    };

    const _handleClearAll = () => {
        setFilterPortfolioFor(RESET_FILTER);
        setFilterInvestmentType(RESET_FILTER);
    };

    return (
        <div className={`position-absolute pt-3 z-index-99 top-100 end-0 w-350px`}
            tabIndex="-1"
            aria-labelledby="portfolio-filter-modal"
            aria-hidden="true">
            <div className={`p-3 e-bg-white e-border-radius-24 e-box-shadow-filter-modal`}>
                <div className='d-flex justify-content-between align-items-center mb-2' >
                    <h6 className='e-text-charleston-green e-alt-font-poppins e-font-14-res e-font-18 e-font-weight-600 line-height-32px mb-0'>
                        Filter by
                    </h6>
                    <TextButton type={2}
                        icon={false}
                        name="Clear all"
                        fontSize={"e-font-12-res e-font-14"}
                        className="border-0 text-decoration-hover-underline"
                        onClick={_handleClearAll} />
                </div>
                <p className='e-text-charleston-green e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-500 line-height-24px letter-spacing-5 margin-12px-bottom'>
                    Portfolio for
                </p>
                <div className='d-flex flex-wrap gap-2 mb-3'>
                    {
                        (props.filterOptionsPortfolioFor || []).map((item, key) => (
                            <span className={`${filterPortfolioFor?.id == item.id ? "e-bg-lavender-web e-text-egyptian-blue" : "e-bg-concrete-gray e-text-dark-liver "} e-font-weight-400 cursor-pointer  e-alt-font-poppins e-font-12  line-height-24px e-border-radius-16 padding-2px-tb padding-10px-lr`}
                                key={key}
                                onClick={() => _handleFilterTypeSelect(item, 1)}>
                                {item.label}
                            </span>
                        ))
                    }

                </div>
                {
                    props.noInvestmentTypeFilter !== true &&
                    <>
                        <p className='e-text-charleston-green e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-500 line-height-24px letter-spacing-5 margin-12px-bottom'>
                            Investment types
                        </p>
                        <div className='d-flex flex-wrap gap-2 mb-4'>
                            {
                                filter_investment_options.map((item, key) => (
                                    <span className={`${filterInvestmentType?.id == item.id ? "e-bg-lavender-web e-text-egyptian-blue" : "e-bg-concrete-gray e-text-dark-liver "} e-font-weight-400 cursor-pointer  e-alt-font-poppins e-font-12  line-height-24px e-border-radius-16 padding-2px-tb padding-10px-lr`}
                                        key={key}
                                        onClick={() => _handleFilterTypeSelect(item, 2)}>
                                        {item.label}
                                    </span>
                                ))
                            }

                        </div>
                    </>
                }
                <div className="d-flex align-items-center gap-2 mt-2">
                    <SecondaryButton name="Cancel"
                        className="w-100 py-sm-3 py-2 e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray "
                        onPress={_handleOnClickCancelbtn}
                        borderRadius="e-border-radius-10" />
                    <PrimaryButton name="Apply"
                        className="w-100 e-font-16 py-2 py-sm-3 e-border-radius-10"
                        onPress={_handleOnClickApplybtn} />
                </div>
            </div>
        </div>
    );
};

export default memo(PortfolioFilterModal);